import 'jquery.ripples';
let isRippleEffectActive = false;

const startRippleEffect = () => {
  if (isRippleEffectActive) return;

  isRippleEffectActive = true;
  $('.ripple').ripples({
    interactive: false,
    resolution: 200,
    dropRadius: 5
  });

  const runRipples = () => {
    let count = 0;
    const f_drop = setInterval(() => {
      const x = Math.random() * $('.ripple').outerWidth();
      const y = Math.random() * $('.ripple').outerHeight();
      const dropRadius = 80;
      const strength = 0.04 + Math.random() * 0.04;
      $('.ripple').ripples('drop', x, y, dropRadius, strength);

      count++;
      if (count > 1) {
        clearInterval(f_drop);
        // 再度リップルエフェクトを行うまでの遅延を設定
        setTimeout(runRipples, 8000);
      }
    }, 500);
  };

  runRipples();
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      startRippleEffect();
      // 一度発動させたら再び監視しないためにオブザーバーを解除する
      observer.unobserve(entry.target);
    }
  });
});

observer.observe(document.querySelector('.message-sec'));
